import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import styles from './News.module.less'
import useFetch from '@/api/useFetch';


function Index({ history }) {
  const NewsType = ['game', 'company']
  const { i18n, t } = useTranslation()
  const [curTab, setCurTab] = useState('game')
  const { response } = useFetch('getNews')
  const news = response.filter(i => i.cate === curTab)

  useEffect(() => {
    //切换语言时要做的事情
    // console.log('init', i18n.language)
  }, [i18n.language])

  // const news = {
  //   game: [
  //     {
  //       id: 1,
  //       title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫冒险1',
  //       desc: '创意国风横版单机手游末剑之路湖东二惊喜回归，非常时单机手游惊喜狂欢回归'
  //     },
  //     { id: 2, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险2', date: '05-18' },
  //     { id: 3, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险3', date: '05-18' },
  //     { id: 4, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险4', date: '05-18' },
  //     { id: 5, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险5', date: '05-18' },
  //   ],
  //   company: [
  //     {
  //       id: 11,
  //       title: '伯雷公主与骑士唤醒冠军之剑的占领四极冒险11',
  //       desc: '创意国风横版单机手游末剑之路湖东二惊喜回归，非常时单机手游惊喜狂欢回归'
  //     },
  //     { id: 22, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险22', date: '05-18' },
  //     { id: 33, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险33', date: '05-18' },
  //     { id: 43, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险43', date: '05-18' },
  //     { id: 55, title: '伯雷公主与骑士唤醒冠军之剑的占领四极地宫获得大冒险55', date: '05-18' },
  //   ]
  // };

  const changeTab = (tab, e) => {
    e && e.preventDefault();
    setCurTab(tab);
  }

  return (
    <div className={styles.news}>
      <div className={styles.tab}>
        <a className={`${styles.item} ${curTab === NewsType[0] ? styles.active : ''}`} href="#a" onClick={(e) => {
          changeTab(NewsType[0], e);
        }}>{ t('gameNews') }</a>
        <a className={`${styles.item} ${curTab === NewsType[1] ? styles.active : ''}`} href="#a" onClick={(e) => {
          changeTab(NewsType[1], e);
        }}>{ t('companyNews') }</a>
        <Link to="/news" className={styles.more}>{ t('more') }&gt;&gt;</Link>
      </div>
      <ul className={styles.list}>
        {
          news.map((item, index) => (
            <li key={item.qcmsdid} className={ index === 0 ? styles.first : '' }>
              <span></span>
              <Link to={`/news/${item.qcmsdid}`} target="_blank">{item.title}</Link>
              { index === 0 ? <p>{item.brief.substr(0, 70)}...</p> : <em>{item.recordTime.split(' ')[0]}</em> }
            </li>
          ))
        }
      </ul>
    </div>
  );
}

export default Index;
